// 3A Finans - Enum sabitleri (backend ile senkron)

export const BELGE_TURLERI = ["G.R", "Fatura", "E-Fatura", "E-Arşiv", "Satış", "İş Emri", "Proforma Fatura"];
export const KANALLAR = ["Sigorta-Anlaşmalı", "Sigorta-Anlaşmasız", "Bireysel", "Kurumsal"];
export const BOLUMLER = ["Kaporta", "Boya", "Mekanik", "Elektrik", "Trim", "Pasta-Cila", "Diğer", "Satış Sonrası Hizmetler"];
export const ALT_HIZMETLER = ["Pasta-Cila", "PPF", "Yıkama", "Diğer"];
export const TAHSILAT_DURUMLARI = ["Bekliyor", "Tahsil Edildi", "Kısmi"];
export const ODEME_SEKILLERI = ["Banka", "Nakit", "Kredi Kartı", "Çek", "Kasa"];
export const ODEME_YERLERI = ["Kasa", "Banka", "Yönetim Tahsilatı", "Tedarikçi Ödemesi"];

export const KAYIT_TIPLERI = ["Fatura", "İş Emri"];
export const MALIYET_KATEGORILERI = ["Yedek Parça", "Boya Malzemesi", "Dış İşçilik / Taşeron", "Sarf Malzeme", "Diğer"];

// Gelir türleri (Ciro > Yeni Kayıt üst seçimi)
export const GELIR_TURLERI = [
  { value: "Araç", label: "Araç Faturası" },
  { value: "Hizmet", label: "Hizmet Faturası" },
  { value: "Diğer", label: "Diğer Fatura" },
];
export const HIZMET_TURLERI = ["Danışmanlık", "Eğitim", "Teknik Hizmet", "Organizasyon", "Kiralama", "Diğer"];

// Statü görünen adları (DB değerleri değişmedi — takip vade sistemi üzerinden yürür)
export const TAHSILAT_ETIKETLERI = {
  "Bekliyor": "Açık (Vadeli)",
  "Kısmi": "Kısmi Tahsilat",
  "Tahsil Edildi": "Tahsil Edildi",
};

export const SSH = "Satış Sonrası Hizmetler";

export const bugun = () => new Date().toISOString().slice(0, 10);

export const TAHSILAT_BADGE = {
  "Bekliyor": "bg-amber-50 text-amber-800 border border-amber-200 hover:bg-amber-50",
  "Tahsil Edildi": "bg-emerald-50 text-emerald-800 border border-emerald-200 hover:bg-emerald-50",
  "Kısmi": "bg-blue-50 text-blue-800 border border-blue-200 hover:bg-blue-50",
};
